export default __webpack_public_path__ + "static/media/gallery_04.64685ad1.jpg";